import { useEffect, useState } from 'react';
import { paymentApi } from '../api/payment';

/**
 * Whether the org's Stripe Connect account is active (able to take card payments).
 *
 * Returns:
 *   true  - connect status is 'active'
 *   false - positively known to be not connected / restricted
 *   null  - unknown (still loading, no orgId, or the status fetch failed)
 *
 * Callers must treat null as "don't block" — the backend enforces the real gate
 * at payment-intent/publish time regardless.
 */
export default function usePayoutsReady(organisationId, enabled = true) {
    const [payoutsReady, setPayoutsReady] = useState(null);

    useEffect(() => {
        if (!enabled || !organisationId) {
            setPayoutsReady(null);
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const status = await paymentApi.getConnectStatus(organisationId);
                if (!cancelled) setPayoutsReady(status?.status === 'active');
            } catch {
                if (!cancelled) setPayoutsReady(null);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [organisationId, enabled]);

    return payoutsReady;
}
